import classNames from 'classnames';
import { useEffect, useState } from 'react';

interface IQuantityHelper {
	onChange?: (quantity: number) => void;
	defaultValue?: number;
	render?: (quantity: number) => React.ReactNode;
}

const QuantityHelper: React.FC<IQuantityHelper> = ({ onChange, defaultValue, render }) => {
	const [countQuantity, setQuantity] = useState<number>(1);

	useEffect(() => {
		setQuantity(defaultValue!);
	}, [defaultValue]);

	return (
		<>
			<div className='inline-flex flex-shrink w-auto overflow-hidden text-primary mt-2 rounded-[5px] h-[32px] lg:!h-[48px] lg:mt-0 border border-secondary items-center'>
				<div className={classNames([countQuantity <= 1 && 'cursor-not-allowed'])}>
					<button
						className={classNames([
							'lg:p-4 aspect-square btn btn-ghost h-[32px] lg:!h-fit rounded-none',
							countQuantity <= 1 && 'pointer-events-none',
						])}
						onClick={() => {
							setQuantity(countQuantity - 1);
							onChange?.(countQuantity - 1);
						}}
					>
						-
					</button>
				</div>
				<input
					className='outline-none text-center h-[32px] w-[54px] bg-inherit justify-center items-center aspect-square'
					value={countQuantity > 0 ? countQuantity : ''}
					type='text'
					onChange={(e) => {
						const quantityChange = +e.target.value;
						setQuantity(quantityChange);
						onChange?.(quantityChange);
					}}
					onBlur={(e) => {
						const quantityChange = +e.target.value;
						!quantityChange && setQuantity(1);
						!quantityChange && onChange?.(1);
					}}
				/>

				<div>
					<button
						className={classNames([
							'lg:p-4 aspect-square btn btn-ghost h-[32px] lg:!h-fit rounded-none',
						])}
						onClick={() => {
							setQuantity(countQuantity + 1);
							onChange?.(countQuantity + 1);
						}}
					>
						+
					</button>
				</div>
			</div>
			{render?.(countQuantity)}
		</>
	);
};

export default QuantityHelper;
